import styled from 'styled-components';

export const Card = styled.article`
  background-color: #fcfffc;
  border: none;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
